export const IMAGE_SHOWCASE_OPACITY_KEY = Symbol('imageShowcaseOpacity')
